export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  itemCount: number;
}

export const categories: Category[] = [
  {
    slug: 'variety',
    name: '综艺娱乐',
    icon: 'ri-tv-line',
    description: '热门综艺节目、搞笑娱乐内容，让你笑口常开，轻松解压每一天。',
    itemCount: 1280,
  },
  {
    slug: 'movie',
    name: '影视剧场',
    icon: 'ri-film-line',
    description: '精选电影、热门电视剧、经典老片，满足你的追剧观影需求。',
    itemCount: 3560,
  },
  {
    slug: 'knowledge',
    name: '知识科普',
    icon: 'ri-lightbulb-line',
    description: '科学、历史、人文、技术知识，寓教于乐，拓宽你的知识视野。',
    itemCount: 890,
  },
  {
    slug: 'music',
    name: '音乐舞蹈',
    icon: 'ri-music-line',
    description: '热门音乐MV、舞蹈教学、音乐现场，让音乐点亮你的生活。',
    itemCount: 2150,
  },
  {
    slug: 'lifestyle',
    name: '生活时尚',
    icon: 'ri-heart-line',
    description: '美食烹饪、旅行Vlog、时尚穿搭、家居设计，发现生活之美。',
    itemCount: 1620,
  },
  {
    slug: 'sports',
    name: '体育竞技',
    icon: 'ri-basketball-line',
    description: '精彩赛事回放、运动教学、极限运动，感受体育的魅力与激情。',
    itemCount: 740,
  },
  {
    slug: 'game',
    name: '游戏电竞',
    icon: 'ri-gamepad-line',
    description: '热门游戏实况、电竞赛事、攻略解说，游戏爱好者的聚集地。',
    itemCount: 1980,
  },
  {
    slug: 'animation',
    name: '动漫二次元',
    icon: 'ri-ghost-line',
    description: '热门动漫、国漫佳作、二次元文化，属于动漫迷的专属频道。',
    itemCount: 1350,
  },
];

export const categoryContentMap: Record<string, { id: string; title: string; coverSeq: string; category: string; duration: string; views: string }[]> = {
  variety: [
    { id: 'v1', title: '欢乐喜剧人第十季：笑料不断的喜剧盛宴', coverSeq: 'variety-01', category: '综艺娱乐', duration: '1:28:35', views: '125.8万' },
    { id: 'v2', title: '奔跑吧兄弟最新季：明星挑战爆笑合集', coverSeq: 'variety-02', category: '综艺娱乐', duration: '1:45:12', views: '98.3万' },
    { id: 'v3', title: '脱口秀大会：幽默段子精彩呈现', coverSeq: 'variety-03', category: '综艺娱乐', duration: '52:18', views: '87.6万' },
    { id: 'v4', title: '密室大逃脱：智力与勇气的双重挑战', coverSeq: 'variety-04', category: '综艺娱乐', duration: '1:12:44', views: '156.2万' },
    { id: 'v5', title: '明星大侦探：烧脑推理全程高能', coverSeq: 'variety-05', category: '综艺娱乐', duration: '1:35:20', views: '201.4万' },
    { id: 'v6', title: '向往的生活：慢综艺中的田园诗意', coverSeq: 'variety-06', category: '综艺娱乐', duration: '1:08:55', views: '78.9万' },
    { id: 'v7', title: '极限挑战：男人帮的冒险之旅', coverSeq: 'variety-07', category: '综艺娱乐', duration: '1:42:10', views: '182.7万' },
    { id: 'v8', title: '声入人心：美声与流行的完美融合', coverSeq: 'variety-08', category: '综艺娱乐', duration: '1:15:33', views: '65.3万' },
  ],
  movie: [
    { id: 'm1', title: '流浪地球3：人类命运的新篇章', coverSeq: 'movie-01', category: '影视剧场', duration: '2:15:40', views: '356.2万' },
    { id: 'm2', title: '长安十二时辰：盛唐悬疑巨制', coverSeq: 'movie-02', category: '影视剧场', duration: '45:20', views: '198.7万' },
    { id: 'm3', title: '繁花：上海滩的岁月故事', coverSeq: 'movie-03', category: '影视剧场', duration: '55:12', views: '275.4万' },
    { id: 'm4', title: '三体：宇宙文明的史诗', coverSeq: 'movie-04', category: '影视剧场', duration: '1:48:30', views: '412.8万' },
    { id: 'm5', title: '狂飙：扫黑除恶大剧', coverSeq: 'movie-05', category: '影视剧场', duration: '50:45', views: '523.1万' },
    { id: 'm6', title: '封神第二部：神话史诗续篇', coverSeq: 'movie-06', category: '影视剧场', duration: '2:08:15', views: '298.6万' },
  ],
  knowledge: [
    { id: 'k1', title: '宇宙的奥秘：黑洞与时间旅行', coverSeq: 'knowledge-01', category: '知识科普', duration: '28:15', views: '45.6万' },
    { id: 'k2', title: '人类文明简史：从远古到未来', coverSeq: 'knowledge-02', category: '知识科普', duration: '35:42', views: '38.2万' },
    { id: 'k3', title: 'AI时代：人工智能如何改变世界', coverSeq: 'knowledge-03', category: '知识科普', duration: '22:10', views: '67.8万' },
    { id: 'k4', title: '经济学入门：理解市场运行逻辑', coverSeq: 'knowledge-04', category: '知识科普', duration: '30:55', views: '29.4万' },
  ],
  music: [
    { id: 'mu1', title: '华语金曲榜：年度最佳音乐合集', coverSeq: 'music-01', category: '音乐舞蹈', duration: '1:02:30', views: '189.5万' },
    { id: 'mu2', title: '古典音乐鉴赏：贝多芬交响曲', coverSeq: 'music-02', category: '音乐舞蹈', duration: '45:18', views: '56.3万' },
    { id: 'mu3', title: '街舞大赛：舞者热血对决', coverSeq: 'music-03', category: '音乐舞蹈', duration: '38:44', views: '112.7万' },
    { id: 'mu4', title: '独立音乐人：原创作品精选', coverSeq: 'music-04', category: '音乐舞蹈', duration: '55:20', views: '43.8万' },
  ],
  lifestyle: [
    { id: 'l1', title: '家常菜教程：30道经典中式菜肴', coverSeq: 'lifestyle-01', category: '生活时尚', duration: '42:15', views: '89.3万' },
    { id: 'l2', title: '日本旅行攻略：东京京都深度游', coverSeq: 'lifestyle-02', category: '生活时尚', duration: '28:50', views: '67.4万' },
    { id: 'l3', title: '极简穿搭：打造高级感日常造型', coverSeq: 'lifestyle-03', category: '生活时尚', duration: '18:35', views: '52.1万' },
    { id: 'l4', title: '小户型装修：空间利用最大化', coverSeq: 'lifestyle-04', category: '生活时尚', duration: '25:40', views: '71.6万' },
  ],
  sports: [
    { id: 's1', title: 'NBA精彩集锦：年度最佳扣篮合集', coverSeq: 'sports-01', category: '体育竞技', duration: '15:30', views: '234.8万' },
    { id: 's2', title: '足球世界杯：经典进球回顾', coverSeq: 'sports-02', category: '体育竞技', duration: '22:18', views: '198.5万' },
    { id: 's3', title: '瑜伽入门：30天坚持计划', coverSeq: 'sports-03', category: '体育竞技', duration: '35:12', views: '76.9万' },
  ],
  game: [
    { id: 'g1', title: '原神攻略：新手必看的10个技巧', coverSeq: 'game-01', category: '游戏电竞', duration: '18:45', views: '156.3万' },
    { id: 'g2', title: 'LOL世界赛：决赛精彩回顾', coverSeq: 'game-02', category: '游戏电竞', duration: '55:20', views: '289.7万' },
    { id: 'g3', title: '黑神话悟空：全Boss通关攻略', coverSeq: 'game-03', category: '游戏电竞', duration: '42:10', views: '198.4万' },
  ],
  animation: [
    { id: 'a1', title: '斗罗大陆：最新剧情深度解析', coverSeq: 'animation-01', category: '动漫二次元', duration: '25:30', views: '178.2万' },
    { id: 'a2', title: '鬼灭之刃：无限城篇预告分析', coverSeq: 'animation-02', category: '动漫二次元', duration: '20:15', views: '145.6万' },
    { id: 'a3', title: '罗小黑战记：温暖治愈的国漫佳作', coverSeq: 'animation-03', category: '动漫二次元', duration: '32:40', views: '89.3万' },
  ],
};